import type { TypeFetchErrorPayload, TypeRequestError, TypeRequestErrorParsed } from './types';

// ----------------------------------------------------------------------------

class FetchError extends Error {
    data: unknown;
    status: number;
    statusText: string;

    constructor({ data, message, status, statusText }: TypeFetchErrorPayload) {
        super(message);

        this.data = data;
        this.name = 'FetchError';
        this.status = status;
        this.statusText = statusText;
    }
}

// ----------------------------------------------------------------------------

function parseError(err: TypeRequestError): TypeRequestErrorParsed {
    const status = err.status ?? 0;
    const isServerError = status >= 500 || status === 0;
    const message = err.data?.message ?? err.message ?? err.statusText ?? 'Unknown error';

    return {
        status,
        isServerError,
        message,
    };
}

// ----------------------------------------------------------------------------

export { FetchError, parseError };
